import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  src: "/fonts/Roboto-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Roboto-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

Font.register({
  family: "Oswald",
  src: "/fonts/Oswald-Regular.ttf",
  fontWeight: "normal",
  fontStyle: "normal",
  fonts: [
    {
      src: "/fonts/Oswald-Bold.ttf",
      fontWeight: "bold",
      fontStyle: "normal",
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    gap: 10,
    backgroundColor: "#fff",
    fontFamily: "Roboto",
    padding: 10,
  },
  section: {
    flexDirection: "column",
    gap: 10,
    justifyContent: "center",
    alignItems: "center",
    margin: 10,
    padding: 10,
  },
  titleText: {
    fontFamily: "Oswald",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 20,
  },
  subtitleText: {
    fontFamily: "Roboto",
    textAlign: "center",
    fontWeight: "normal",
    fontSize: 12,
  },
  normalText: {
    fontFamily: "Roboto",
    fontSize: 10,
    fontWeight: "normal",
    textAlign: "left",
  },
  tableView: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: "1px solid #ccc",
    borderRadius: 5,
    overflow: "hidden",
  },
  tableHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    backgroundColor: "#ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 5,
    borderBottom: "1px solid #ccc",
    fontSize: 10,
    fontFamily: "Roboto",
    fontWeight: "normal",
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
});

export default function ConsumoCartaoPDF({
  data,
  codigoCartao,
  totalCredito,
  totalDebito,
}) {
  const valorTotal = totalCredito - totalDebito;
  const saldoDesbloqueado =
    valorTotal - data[0]?.VALORCARTAO - valorTotal * data[0]?.SALDORES * 0.01;

  return (
    <Document
      creationDate={new Date()}
      author="Santa Ficha"
      title={`Consumo por Cartão - Cartão ${codigoCartao} - ${new Date().toLocaleDateString(
        "pt-BR",
        {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }
      )}`}
      subject="Consumo por Cartão"
      keywords="relatório, consumo, cartão, santa ficha"
      producer="Santa Ficha"
      creator="Santa Ficha"
      language="pt-BR"
    >
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.titleText}>
            Consumo por Cartão - {codigoCartao}
          </Text>
          <Text style={styles.subtitleText}>
            Emitido em{" "}
            {new Date().toLocaleDateString("pt-BR", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </Text>
        </View>

        <View style={styles.tableView}>
          <View style={styles.tableRow}>
            <Text style={{ width: "60%" }}>Valor do Cartão</Text>
            <Text style={{ width: "40%", textAlign: "right" }}>
              {data[0]?.VALORCARTAO.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={{ width: "60%" }}>Saldo Residual</Text>
            <Text style={{ width: "40%", textAlign: "right" }}>
              {Number(data[0]?.SALDORES).toLocaleString("pt-BR", {
                style: "percent",
                currency: "BRL",
              })}
            </Text>
          </View>
        </View>

        <Text style={styles.titleText}>Créditos</Text>
        <View style={styles.tableView}>
          <View style={styles.tableHeader}>
            <Text style={{ width: "18%" }}>Data/Hora</Text>
            <Text style={{ width: "10%" }}>PDV</Text>
            <Text style={{ width: "15%" }}>Turno/Operador</Text>
            <Text style={{ width: "20%" }}>Produto</Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              Valor Unitário
            </Text>
            <Text style={{ width: "10%", textAlign: "right" }}>Quantidade</Text>
            <Text style={{ width: "12%", textAlign: "right" }}>Total</Text>
          </View>

          {data[0]?.credito?.map((row, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={{ width: "18%" }}>
                {new Intl.DateTimeFormat("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(row?.DATAHORA))}
              </Text>
              <Text style={{ width: "10%" }}>{row?.PDV}</Text>
              <Text style={{ width: "15%" }}>
                {row?.TURNO} - {row?.RESPONSAVEL}
              </Text>
              <Text style={{ width: "20%" }}>
                {row?.CODPROD} - {row?.DESCPROD}
              </Text>
              <Text style={{ width: "15%", textAlign: "right" }}>
                {Number(row.VALORUNI).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Text>
              <Text style={{ width: "10%", textAlign: "right" }}>
                {Number(row.QTDE).toLocaleString("pt-BR")}
              </Text>
              <Text style={{ width: "12%", textAlign: "right" }}>
                {Number(row.TOTAL).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Text>
            </View>
          ))}

          <View style={styles.tableHeader}>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "10%" }}></Text>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              Total de Créditos
            </Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              {totalCredito?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
          </View>
        </View>

        <Text style={styles.titleText}>Débitos</Text>
        <View style={styles.tableView}>
          <View style={styles.tableHeader}>
            <Text style={{ width: "18%" }}>Data/Hora</Text>
            <Text style={{ width: "10%" }}>PDV</Text>
            <Text style={{ width: "15%" }}>Turno/Operador</Text>
            <Text style={{ width: "20%" }}>Produto</Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              Valor Unitário
            </Text>
            <Text style={{ width: "10%", textAlign: "right" }}>Quantidade</Text>
            <Text style={{ width: "12%", textAlign: "right" }}>Total</Text>
          </View>

          {data[0]?.debito?.map((row, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={{ width: "18%" }}>
                {new Intl.DateTimeFormat("pt-BR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                }).format(new Date(row?.DATAHORA))}
              </Text>
              <Text style={{ width: "10%" }}>{row?.PDV}</Text>
              <Text style={{ width: "15%" }}>
                {row?.TURNO} - {row?.RESPONSAVEL}
              </Text>
              <Text style={{ width: "20%" }}>
                {row?.CODPROD} - {row?.DESCPROD}
              </Text>
              <Text style={{ width: "15%", textAlign: "right" }}>
                {Number(row.VALORUNI).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Text>
              <Text style={{ width: "10%", textAlign: "right" }}>
                {Number(row.QTDE).toLocaleString("pt-BR")}
              </Text>
              <Text style={{ width: "12%", textAlign: "right" }}>
                {Number(row.TOTAL).toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Text>
            </View>
          ))}

          <View style={styles.tableHeader}>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "10%" }}></Text>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "15%" }}></Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              Total de Débitos
            </Text>
            <Text style={{ width: "15%", textAlign: "right" }}>
              {totalDebito?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
          </View>
        </View>

        <View style={styles.tableView}>
          <View style={styles.tableRow}>
            <Text style={{ width: "60%" }}>Saldo Total</Text>
            <Text style={{ width: "40%", textAlign: "right" }}>
              {valorTotal?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={{ width: "60%" }}>Saldo Desbloqueado</Text>
            <Text style={{ width: "40%", textAlign: "right" }}>
              {saldoDesbloqueado?.toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
}
